interface IPlayerAsset {
    url: string,
    blob: Blob,
    objUrl: string,
}

export default class PlayerAsset implements IPlayerAsset {
    url:string;
    blob: Blob;
    objUrl:string;

    constructor(props:{url:string, blob:Blob}) {
      this.url = props.url;
      this.blob = props.blob;
      this.objUrl = URL.createObjectURL(this.blob);
    }

    async arrayBuffer() {
      return this.blob.arrayBuffer();
    }
}
